import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  Table,
} from "@mui/material";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CloseIcon from "@mui/icons-material/Close";
import JsFileDownloader from "js-file-downloader";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import useNotify from "../utils/useNotify";
import { getTransactionDocs } from "../services/httpCalls";
import SourceIcon from "@mui/icons-material/Source";
import PreviewDocsDownload from "./PreviewDocsDownload";
import { useRecoilValue } from "recoil";
import { transactionClicked } from "../store/gloabalState";
import { styled } from "@mui/material/styles";

import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",

  boxShadow: 24,
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: ".5rem",
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: ".5rem",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
function TransactionDownloadDocs({ downloadDoc }) {
  const transactionId = useRecoilValue(transactionClicked);
  const notify = useNotify();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [docs, setDocs] = useState();
  const fetchtableData = async () => {
    await getTransactionDocs(transactionId)
      .then((res) => {
        setDocs(res);
      })
      .catch((err) => {
        console.log(err);
      });
    handleOpen();
  };
  const cols = [
    {
      colName: "File Name",
      colId: "file name",
    },
    {
      colName: "File Type",
      colId: "file type",
    },
    {
      colName: "Preview",
      colId: "preview",
    },
    {
      colName: "Download",
      colId: "download",
    },
    {
      colName: "Time",
      colId: "time",
    },
  ];
  const extension = (fileName) => {
    return fileName.endsWith("zip");
  };
  return (
    <Box>
      <IconButton onClick={fetchtableData}>
        <SourceIcon
          sx={{
            color: "#2862FF",
            fontSize: "30px",
          }}
        />
      </IconButton>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              p: 1,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            >
              View Files
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              marginBottom: "20px",
              paddingBottom: 2,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            ></Typography>

            <Box p={2}>
              {docs?.length ? (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{
                      maxHeight: "340px",
                    }}
                  >
                    <Table
                      stickyHeader
                      sx={{
                        minWidth: 350,
                        overflowY: "scroll",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          {cols?.map((cols, i) => {
                            return (
                              <StyledTableCell key={i} align="center">
                                {cols.colName}
                              </StyledTableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {docs?.map((value, i) => {
                          let nopreview = extension(value.documentName);
                          let date = new Date(
                            parseInt(value.creationTime)
                          ).toLocaleDateString();
                          let time = new Date(
                            parseInt(value.creationTime)
                          ).toLocaleTimeString();
                          return (
                            <StyledTableRow key={i}>
                              <StyledTableCell
                                sx={{
                                  width: "180px",
                                }}
                                align="center"
                              >
                                {value.documentName}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {value.documentType}
                              </StyledTableCell>
                              {nopreview ? (
                                <StyledTableCell align="center">
                                  No Preview
                                </StyledTableCell>
                              ) : (
                                <StyledTableCell align="center">
                                  <IconButton>
                                    <PreviewDocsDownload
                                      url={value.presignedUrl}
                                    />
                                  </IconButton>
                                </StyledTableCell>
                              )}

                              <StyledTableCell align="center">
                                <IconButton
                                  onClick={() => {
                                    let fileName = value?.documentName.split('.')
                                    let finalName = ''
                                    if (value.documentType !== "Invoice") {
                                      finalName = fileName[0].split("_")
                                      let finalName_ = ''
                                      finalName.forEach((val, i) => {
                                        if (i !== 0) {
                                          finalName_ += val
                                        }
                                      })
                                      finalName = finalName_
                                    }else{
                                      finalName = fileName[0]
                                    }
                                    new JsFileDownloader({
                                      url: value.presignedUrl,
                                      filename: finalName.replace(/[!@#$%^&*()_+{}\[\]:;<>,.?\\\-]/g, '') + '.' + fileName[1]
                                    })
                                      .then((res) => {
                                        notify.success("Download Success!");
                                      })
                                      .catch((err) => {
                                        notify.error("Download Failed!");
                                      });
                                  }}
                                >
                                  <DownloadIcon
                                    sx={{
                                      color: "#1876D1",
                                    }}
                                  />
                                </IconButton>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {
                                  <>
                                    {
                                      <div>
                                        <div>{date}</div>
                                        <div>{time}</div>
                                      </div>
                                    }
                                  </>
                                }
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Box
                  sx={{
                    padding: "3rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <AutoStoriesIcon
                    sx={{
                      fontSize: "100px",
                      color: "#DDE0E4",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      color: "#DDE0E4",
                    }}
                  >
                    No Data
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 3,
                mr: 3,
              }}
            >
              <Box
                sx={{
                  display: docs?.length ? "flex" : "none",
                  alignItems: "center",
                }}
              >
                <Tooltip title="Download all Files" placement="top">
                  <InfoOutlinedIcon
                    sx={{
                      mr: 1,
                      color: "grey",
                    }}
                  />
                </Tooltip>
                <Button
                  variant="contained"
                  onClick={() => {
                    downloadDoc();
                  }}
                >
                  Download all
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal >
    </Box >
  );
}

export default TransactionDownloadDocs;
